<template>
  <div class="Area">
    <div class="title">{{title}}</div>
    <div class="earea">
      <div class="province">
        <div class="p fs18" v-for="(v, p) in area" :class="{selected: p==selectedP }" @click="select(p, 1, v.id)">
          {{p}}
        </div>
      </div>
      <div class="city" v-if="area[selectedP]">
        <div class="scroll">
          <div class="c fs18" v-for="c in area[selectedP].cities" :class="{selected: c==selectedC }"
               @click="select(c, 0)">{{c}}
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="tips">*海外选手请统一报名</div> -->
  </div>
</template>

<script>
  import chinaArea from '@/assets/json/china-area.json'

  export default {
    name: 'Area',
    data() {
      return {
        selectedP: '北京',
        selectedPid: 1,
        selectedC: '东城',
        area: {},
        areaOrder: []
      }
    },
    methods: {
      select(v, isP, id) {
        if (isP) {
          this.updateProvince(v, id)
        } else {
          this.updateCity(v)
        }
      },
      updateProvince(v, id) {
        this.selectedP = v
        this.selectedPid = id
        this.$store.commit('updateEnrollProvince', {
          p: v,
          id: id
        })
        console.log(v, id, this.area)
        this.updateCity(this.area[v].cities[0])
      },
      updateCity(v) {
        this.selectedC = v
        this.$store.commit('updateEnrollCity', v)
      },
      initInput(){
        let userInfo = this.$parent.user
        if (userInfo) {
          if (userInfo.area_id) {
            this.updateProvince(userInfo.province, userInfo.area_id)
          }
          if (userInfo.city) {
            this.updateCity(userInfo.city)
          }
        }
        console.log('son component')
      }
    },
    computed: {
      title() {
        return '报名地区'
      }
      /* area() {*/
      /* return chinaArea*/
      /* },*/
    },
    mounted() {
      this.$http.get('/storage/cities.json')
        .then(res => {
          console.log(res)
          this.area = res.data
          let st = []
          for (let k in res.data) {
            st.push({'name': k, 'id': res.data[k].id})
          }
          /* st.push({'name': 'guoji', 'id': 99999}) */
          st.sort((a, b) => (a.id > b.id) ? 1 : -1)
          this.areaOrder = st.map(a => a.name)
          this.initInput();
        })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .Area{
    width: 62.5vw;
    height: 22.66vw;
    box-sizing: border-box;
    padding-top: 2.4vw;
    padding-bottom: 1.823vw;
    background-image: url(~@/assets/image/enroll/bg-area.png);
    background-size: 62.5vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  .title{
    color: white;
    font-size: 1.875vw;
    line-height: 1.85vw;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .earea{
    display: flex;
    width: 57.3vw;
    justify-content: space-between;
  }

  .province{
    padding-top: .46875vw;
    display: flex;
    flex-wrap: wrap;
    width: 41.5vw;
    align-items: flex-start;
  }

  .city{
    width: 13.85vw;
    height: 14.95vw;
    box-sizing: border-box;
    padding-top: 3.3vw;
    padding-left: 0.68vw;
    padding-right: 0.68vw;
    background-image: url(~@/assets/image/enroll/bg-city.png);
    background-size: 13.85vw;
    overflow: hidden;
    position: relative;
  }

  .city::before{
    content: "请选择市/区";
    color: white;
    position: absolute;
    top: 1.5vw;
    left: 4.8vw;
  }

  .city > .scroll{
    height: 11.7vw;
    overflow-y: scroll;
    -ms-overflow-style: none;
    display: flex;
    flex-wrap: wrap;
    scrollbar-width: none;
  }

  .scrollbar::-webkit-scrollbar{
    display: none;
  }

  .p, .c{
    cursor: pointer;
  }

  .p{
    width: 4.27vw;
    height: 3.23vw;
    margin-right: 0.3vw;
    margin-bottom: 0.4vw;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #35336D;
  }

  .c{
    min-width: 4.16vw;
    height: 2.1875vw;
    display: flex;
    margin-top: 0.4vw;
    padding-left: 0.2vw;
    padding-right: 0.2vw;
    box-sizing: border-box;
    align-items: center;
    justify-content: center;
  }

  .p.selected{
    background-color: #FF7182;
    color: white;
  }

  .c.selected{
    color: white;
    background-color: #BEBCFF;
  }
 .tips{
   color: white;
 }
</style>
